import { IsString, IsNotEmpty, IsDefined } from 'class-validator';
import { RgbaDto } from './RgbaDto';
import { GradientDto } from './GradientDto';
import { IsColor } from './validators/IsColor';

export class ColorDto {
  @IsDefined()
  @IsString()
  @IsNotEmpty()
  name!: string;

  @IsDefined()
  @IsColor()
  value!: RgbaDto | GradientDto;
}
